import React, { useState, useEffect } from "react";
import award from "../src/assets/award2.jpg"
import awards from "../src/assets/award1.jpg";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./Menu1.css";

const AwardPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Responsive styles
  const containerStyle = {
    padding: isMobile ? "5px" : "5px", 
    fontFamily: "Arial, sans-serif"
  };

  const cardStyle = {
    maxWidth: isMobile ? "98%" : "1190px",
    background: "linear-gradient(90deg, #fff, #cb71ca)",
    margin: isMobile ? "2px auto" : "2px auto",
    border: "1px solid #ddd",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
  };

  const headerStyle = {
    color: "#700d69",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: isMobile ? "10px" : "10px",
    fontSize: isMobile ? "1.2rem" : "1.5rem",
  };

  const textStyle = {
    textAlign: "justify", 
    lineHeight: "1.6", 
    fontSize: isMobile ? "0.85rem" : "1rem",
    marginBottom: isMobile ? "8px" : "10px",
  };

  const paddingStyle = {
    padding: isMobile ? "10px" : "15px"
  };

  const imageContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: isMobile ? "10px" : "15px",
  };

  const awardImageStyle = {
    width: isMobile ? "95%" : "700px",
    maxWidth: isMobile ? "320px" : "700px",
    height: "auto",
    display: "block",
    borderRadius: isMobile ? "5px" : "0px",
  };

  const bannerImageStyle = {
    width: "100%",
    height: isMobile ? "180px" : "340px",
    objectFit: "cover",
  };

  return (
    <div>
      <Navbar/>
      
      {/* Mobile Menu Toggle Button */}
      {isMobile && (
        <div className="mobile-menu-toggle" onClick={toggleSidebar}>
          <div className={`hamburger ${sidebarOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar}></div>
      )}

      <div className={`small-container ${isMobile ? 'mobile' : ''}`} style={{gap: isMobile ? "0px" : "5px"}}>
        {/* Sidebar */}
        <div className={`small-sidebar ${isMobile ? (sidebarOpen ? 'mobile-open' : 'mobile-closed') : ''}`}>
          {/* Top wave */}
          <div className="sidebar-wave-top"></div>
          <ul>
            <li>
              <a href="presidents_message" onClick={isMobile ? closeSidebar : undefined}>President's Message</a>
            </li>
            <li><a href="documents" onClick={isMobile ? closeSidebar : undefined}>Annual Report</a></li>
            <li><a href="interest" onClick={isMobile ? closeSidebar : undefined}>Interest Rate</a></li>
            <li><a href="loans" onClick={isMobile ? closeSidebar : undefined}>Loans</a></li>
            <li><a href="awards" onClick={isMobile ? closeSidebar : undefined}>Awards</a></li>
          </ul>
          {/* Bottom wave */}
          <div className="sidebar-wave"></div>
        </div>

        {/* Content Section */}
        <div className="small-content">
          <div className="image-wrapper">
            <img src={awards} alt="About Us" style={bannerImageStyle} />
          </div>
        </div>
      </div>

      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={paddingStyle}>
            <h2 style={headerStyle}>
              Awards
            </h2>
            <p style={textStyle}>
              Our Souharda is recognized by Karnataka State Souharda Federal Cooperative
              Limited as the best Souharda among Souharda Cooperatives of Mysore Division.
              We thank all Members for continuous support for winning this award.
            </p>
          </div>
          
          <div style={imageContainerStyle}>
            <img
              src={award}
              alt="Award Ceremony"
              style={awardImageStyle}
            />
          </div>

          <div style={paddingStyle}>
            <p style={textStyle}>
              Our President Mr. S R Sathischandra, Director Mr. Sunil Borkar and General Manager Mr. Vasanth Received this Award in 60th All India Co-operative saptah -2013 held at T. Chennayya hall Kolar District. Co-operative minister Mr. H. Mahadeva Prasad, Mr. G T Devegowda President of Karnataka State co-operative Mahamandala, Mr K. R. Ramesh Kumar Ex. President of Karnataka Legislative Assembly, Mr. Gurunath Jyanthikar President of Karnataka State Souharda Federal Co-operative were present in this Function.
            </p>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default AwardPage;